import { render, staticRenderFns } from "./AccountUser.vue?vue&type=template&id=4a9d1ab0&scoped=true&lang=html&"
import script from "./AccountUser.vue?vue&type=script&lang=js&"
export * from "./AccountUser.vue?vue&type=script&lang=js&"
import style0 from "./AccountUser.vue?vue&type=style&index=0&id=4a9d1ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d1ab0",
  null
  
)

export default component.exports